import React from 'react';
import CoffeeRain from './components/CoffeeRain';
import LottieBlock from './components/LottieBlock';
import ParallaxBlock from './components/ParallaxBlock';
import foreground1 from './for_web/homescreen.png';
import foreground2 from './for_web/mapscreen.png';
import foreground3 from './for_web/dayoldscreen.png';
import foreground4 from './for_web/couponscreen.png';
import CafeFormBlock from './components/CafeFormBlock';
import CollidingBlock from './components/CollidingTap';
import './Block.css';
import animation1 from './lotties/lottie_bell.json';
import animation3 from './lotties/connectcafe.json';
import animation4 from './lotties/connect.json';
import animation5 from './lotties/coffee_loading.json';
import animation_punch_card from './lotties/lottie_loyalty_card_intro.json';
import animation_getpaid from './lotties/lottie_getpaid.json';
import animation_go_green from './lotties/gogreen.json';
import IntroVideo from './components/IntroVideo';
import videoSource from './lotties/BeanBonusIntro3.mp4';
import DownloadAppButton from './components/DownloadAppButton';
import parallaxbackground from './coffeetexture.png';
import FloatingButton from './components/FloatingButton';
import IntroBlock from './components/IntroBlock';
import CafeMap from './components/CafeMap';

function LandingPage() {
  return (
    <div className="body" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <CoffeeRain />
      <IntroBlock />
      <CafeMap />
      {/* <FloatingButton /> */}
      <LottieBlock
        animationData={animation_punch_card}
        header={"Every Cafe Every Reward"}
        description={"none"}
        subdescription={["Time to toss out those stamp cards.", "This app collects loyalty rewards from all your cafes!", "Enjoy that free sip feeling."]}
        slide="left"
      />
      {/* <DownloadAppButton /> */}
      <ParallaxBlock backgroundImage={parallaxbackground} foregroundImageSrc={foreground1} textContent={"Digital\nStamp\nCard"} number={'two'} />
      <LottieBlock
        animationData={animation1}
        header={"Save Up To 90%"}
        description={"none"}
        subdescription={["Stay notified when day-olds hit the shelves.", "Donuts for 50-cents, muffins for a dollar, save big on baked goods.", "Be the first to know and never miss out."]}
        slide="left"
      />
      <ParallaxBlock backgroundImage={parallaxbackground} foregroundImageSrc={foreground4} textContent={"Coupon\nOffers"} number={'one'} />
      <LottieBlock
        animationData={animation_getpaid}
        header={"Get Paid Cash"}
        description={"none"}
        subdescription={["Explore cafes to earn beans.", "Our best explorers get their cards loaded up at the end of each month.", "Either cash out or use it for coffees and treats!"]}
        slide="left"
      />
      <ParallaxBlock backgroundImage={parallaxbackground} foregroundImageSrc={foreground3} textContent={"Fresh\nDay\nOlds"} number={'two'} />      
      <LottieBlock
        animationData={animation3}
        header={"Support Your Community"}
        description={"none"}
        subdescription={["Help small businesses thrive by choosing local.", "Support artisanal craftsmanship.", "Never miss any events by knowing when and where all the latest buzz is happening!"]}
        slide="right"
      />
      <ParallaxBlock backgroundImage={parallaxbackground} foregroundImageSrc={foreground2} textContent={"Explore\nNew\nGems"} number={'one'} />
      <LottieBlock
        animationData={"none"}
        header="What Are You Waiting For?"
        description={"none"}
        subdescription={["Find us on the App Store!", "Contact Us", "Phone: 416-500-5506", "Email: info@beanbonus.ca"]}
        slide="right"
      />
      <DownloadAppButton />
      <CafeFormBlock />
    </div>
  );
}

export default LandingPage;